import { NavLink, useLocation } from "react-router-dom";
import { IoLogoWhatsapp } from "react-icons/io";
import { IoCallSharp, IoMail } from "react-icons/io5";
import { FaChevronCircleLeft } from "react-icons/fa";

import { appConfig } from "../config/appConfig";
import nobleWhite240 from "../props/logos/nobleWhite240px.png";

const Navbar = () => {
  const location = useLocation();

  return (
    <div className="bg-white shadow-sm border-b border-gray-200/80 w-full py-4 lg:py-3">
      <div className="container mx-auto px-4 md:px-6 flex flex-wrap justify-between items-center gap-3">
        {/* Logo and Brand Section */}
        <div className="flex items-center gap-4 text-gray-800">
          {location.pathname === "/" ? (
            <div className="bg-gradient-to-r from-themeColor1 to-themeColor2 p-3 rounded-xl shadow-md">
              <img
                src={nobleWhite240}
                alt="Noble Wiring"
                className="h-8 lg:h-9 filter brightness-0 invert"
              />
            </div>
          ) : (
            <button className="my-smooth-transition-1 bg-gradient-to-r from-themeColor1 to-themeColor2 hover:from-themeColor2 hover:to-themeColor1 text-white p-2.5 rounded-full shadow-md hover:shadow-lg transform hover:scale-105">
              <NavLink to="/">
                <FaChevronCircleLeft size={18} />
              </NavLink>
            </button>
          )}

          <div
            className={`${
              location.pathname === "/" ? "hidden lg:flex" : "flex"
            } items-center gap-4`}
          >
            <span className="text-gray-300 text-2xl font-light">|</span>
            <div className="flex flex-col">
              <h3
                className={`${
                  location.pathname === "/" ? "hidden" : "block lg:hidden"
                } text-gray-800 font-bold text-base leading-tight`}
              >
                SAE
              </h3>
              <h3 className="hidden lg:block text-gray-800 font-bold text-lg leading-tight">
                Samson Auto Electricals
              </h3>
              <span className="hidden lg:block text-xs text-gray-500 font-medium tracking-wide">
                AUTOMOTIVE ELECTRICAL SOLUTIONS
              </span>
            </div>
          </div>
        </div>

        {/* Contact Actions */}
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 bg-gray-50/80 p-1.5 rounded-full border border-gray-100">
            <a
              href={`tel:${appConfig.contact.ccNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className="my-smooth-transition-1 bg-blue-500 hover:bg-blue-600 text-white p-2 rounded-full shadow-sm hover:shadow-md transform hover:scale-110"
              title="Call Us"
            >
              <IoCallSharp size={16} />
            </a>

            <a
              href={appConfig.contact.ccWhatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="my-smooth-transition-1 bg-green-500 hover:bg-green-600 text-white p-2 rounded-full shadow-sm hover:shadow-md transform hover:scale-110"
              title="WhatsApp"
            >
              <IoLogoWhatsapp size={16} />
            </a>

            <a
              href={`mailto:${appConfig.contact.email}`}
              target="_blank"
              rel="noopener noreferrer"
              className="my-smooth-transition-1 bg-themeColor3 hover:bg-red-700 text-white p-2 rounded-full shadow-sm hover:shadow-md transform hover:scale-110"
              title="Email Us"
            >
              <IoMail size={16} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
